const GTM_ID = 'GTM-P5ZFH2P'

const googleTag = () => `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
  {'gtm.start': new Date().getTime(),event:'gtm.js'}
  );var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${GTM_ID}');
`

const googleTagNoScript = () => `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" 
    height="0" width="0" style="display:none;visibility:hidden"/>
`

const useGTM = () => {
  const hasWindow = () => {
    return typeof window === 'object'
  }

  const sendToGtm = (data) => {
    // defer seting to data layer
    setTimeout(() => {
      if (hasWindow()) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(data)
      }
    })
  }

  const trackEvent = (eventName) => {
    sendToGtm({
      event: eventName,
    })
  }

  return { sendToGtm, trackEvent }
}

export { useGTM, googleTag, googleTagNoScript }
